import { CommonUtility } from './common.utility';

export class DomUtility {
  public static getIFrameDocument(frame: Element): Document | null {
    if (CommonUtility.isHostObjectProperty(frame, 'contentDocument')) {
      try {
        if ((frame as HTMLIFrameElement).contentDocument) {
          return (frame as HTMLIFrameElement).contentDocument;
        }
      } catch (e) {
        console.error(e);
        return null;
      }
    }

    if (CommonUtility.isHostObjectProperty(frame, 'contentWindow')) {
      try {
        if ((frame as HTMLIFrameElement).contentWindow.document) {
          return (frame as HTMLIFrameElement).contentWindow.document;
        }
      } catch (e) {
        console.debug(e);
        return null;
      }
    }

    return null;
  }

  /**
   * checks if 'cssSelector' would pass as a valid css selector. also accepts nullish strings as valid.
   *
   * @param cssSelector the string to test
   * @returns true if the 'cssSelector' is either a valid css selector string, or nullish. false otherwise.
   */
  public static isCssSelectorValid(cssSelector: string): boolean {
    try {
      document.querySelector(cssSelector);
    } catch (e: any) {
      return false;
    }

    return true;
  }

  /**
   * Calculates the current scroll position as a percentage (0-1) of the scrollable area.
   * Returns 0 if the container is not scrollable.
   */
  public static getScrollPercentage(container: HTMLElement): number {
    const maxScroll = container.scrollHeight - container.clientHeight;
    return maxScroll > 0 ? container.scrollTop / maxScroll : 0;
  }

  /**
   * Restores the scroll position of a container based on a percentage (0-1).
   * Does nothing if the container is not scrollable.
   */
  public static restoreScrollPosition(container: HTMLElement, percentage: number): void {
    const maxScroll = container.scrollHeight - container.clientHeight;
    if (maxScroll > 0) {
      container.scrollTop = percentage * maxScroll;
    }
  }
}
